import pxToRem from './../utils/pxToRem';

export const limits = {
  max: pxToRem(1920),
  md: pxToRem(1200),
  lg: pxToRem(1600)
}
